import { Link } from "react-router-dom";

const steps = [
  {
    step: "01",
    icon: "ri-chat-1-line",
    title: "Inquiry",
    desc: "Share the target brands, SKUs, quantities, destination and preferred shipping method.",
  },
  {
    step: "02",
    icon: "ri-file-text-line",
    title: "Quotation",
    desc: "Receive pricing, MOQ guidance, availability, lead time and recommended freight options.",
  },
  {
    step: "03",
    icon: "ri-check-double-line",
    title: "Order Confirmation",
    desc: "Confirm the purchase order, payment terms, product list and shipment plan.",
  },
  {
    step: "04",
    icon: "ri-search-line",
    title: "Inspection & Packing",
    desc: "Check products, quantities, expiry dates, labeling and export packing requirements.",
  },
  {
    step: "05",
    icon: "ri-ship-2-line",
    title: "Shipment",
    desc: "Dispatch by LCL, FCL or air freight with standard export documentation.",
  },
  {
    step: "06",
    icon: "ri-customer-service-2-line",
    title: "Delivery Support",
    desc: "Provide shipment tracking and post-shipment communication.",
  },
];

export default function HowWeWork() {
  return (
    <section className="w-full px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-px bg-accent-500" />
            <span className="font-label text-[11px] tracking-[0.22em] uppercase text-accent-700">
              Process
            </span>
            <span className="w-8 h-px bg-accent-500" />
          </div>
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl lg:text-6xl leading-[1.05] font-light">
            From Product Request
            <br />
            <span className="italic">to Global Shipment</span>
          </h2>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5 md:gap-6">
          {steps.map((s, i) => (
            <div key={s.step} className="relative group">
              <article className="flex flex-col items-center text-center p-6 md:p-7 rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all h-full">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                  <i className={`${s.icon} text-2xl w-6 h-6 flex items-center justify-center`} />
                </div>
                <div className="mt-4 font-label text-[10px] tracking-[0.3em] text-accent-700 mb-2">
                  {s.step}
                </div>
                <h3 className="font-heading text-foreground-950 text-xl md:text-2xl leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-foreground-700 text-[14px] leading-relaxed font-light">
                  {s.desc}
                </p>
              </article>

              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute -right-5 top-1/2 -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-foreground-400 text-xl" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link
            to="/contact"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-3 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors font-label text-[13px] tracking-[0.16em] uppercase"
          >
            Start Your Inquiry
            <i className="ri-arrow-right-up-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}